import React, { FC } from 'react'

// MUI
import { Box, Container, Grid, Stack } from '@mui/material'
import CallIcon from '@mui/icons-material/Call'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail'

// UI
import { BlackNextLink, PaddTwentyFour } from '@/ui'
import { ContactInfoDiv, IconBgDiv, LabelSubTitle, LabelTitle, SubDiv } from './styles'

const AboutContactInfo: FC = () => {
  return (
    <ContactInfoDiv>
      <Container maxWidth="xl">
        <PaddTwentyFour>
          <Grid container justifyContent={{ md: 'space-between', xs: 'center' }} alignItems="center" spacing={{ md: 4, xs: 2 }}>
            <Grid item xs={12} sm={6} md={4}>
              <SubDiv>
                <Stack direction="row" gap={2}>
                  <IconBgDiv>
                    <CallIcon />
                  </IconBgDiv>

                  <Box>
                    <LabelTitle>Phone:</LabelTitle>
                    <BlackNextLink href="tel:+917567371612" aria-label="+91 - 756 737 1612" role="link" target="_blank" sx={{ color: '#6a6a8e' }}>
                      <LabelSubTitle>+91 - 756 737 1612</LabelSubTitle>
                    </BlackNextLink>
                  </Box>
                </Stack>
              </SubDiv>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <SubDiv>
                <Stack direction="row" gap={2}>
                  <IconBgDiv>
                    <LocationOnIcon />
                  </IconBgDiv>

                  <Box>
                    <LabelTitle>Address:</LabelTitle>

                    <LabelSubTitle>Bhaveshvar nagar, Behind Ajani Tower Building, Bhuj - Kachchh, Gujarat - 370 001</LabelSubTitle>
                  </Box>
                </Stack>
              </SubDiv>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <SubDiv>
                <Stack direction="row" gap={2}>
                  <IconBgDiv>
                    <AlternateEmailIcon />
                  </IconBgDiv>

                  <Box>
                    <LabelTitle>Email:</LabelTitle>

                    <BlackNextLink href="mailto:zishansameja1@gmail.com" aria-label="zishansameja1@gmail.com" target="_blank" role="link" sx={{ color: '#6a6a8e' }}>
                      <LabelSubTitle>zishansameja1@gmail.com</LabelSubTitle>
                    </BlackNextLink>
                  </Box>
                </Stack>
              </SubDiv>
            </Grid>
          </Grid>
        </PaddTwentyFour>
      </Container>
    </ContactInfoDiv>
  )
}

export default AboutContactInfo
